import datepickerFactory from "jquery-datepicker";
// import moment from "moment";

export function datepicker() {
    datepickerFactory(jQuery);
    let $datepicker = $(".datepicker");
    const path = typeof assets_path !== "undefined" ? assets_path : "../";

    $datepicker.datepicker({
        dayNamesMin: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
        showOn: "button",
        buttonImage: path + "images/calendar.svg",
        buttonImageOnly: true,
        buttonText: "Select date"
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/datepicker.js